// css
import "../../scss/pages/page-lifejournal.scss";

// npm
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// utils
import foundation from "../_utils/foundation";
foundation();

// libs
import ScrollObserver from "../_libs/ScrollObserver";
import HeaderSideNav from "../_libs/HeaderSideNav";
import Ranking from "../_libs/Ranking";

document.addEventListener("DOMContentLoaded", () => {
	HeaderSideNav();
	Ranking();
	setTimeout(function () {
		document.querySelectorAll(".js-first-animation").forEach((element) => {
			element.classList.add("is-active");
		});
	}, 400);

	setTimeout(function () {
		document.querySelectorAll(".js-fv").forEach((element) => {
			element.classList.add("is-active");
		});
	}, 550);

	setTimeout(function () {
		const posts = document.querySelectorAll(".js-fv-slider");
		const copyElement = document.querySelector(".js-fv-slider-copy");
		if (copyElement) {
			copyElement.classList.add("is-show");
		}
		gsap.to(posts, {
			opacity: 1,
			y: 0,
			duration: 1.5,
			stagger: 0.15,
			ease: "power2.out",
		});
	}, 550);

	const posts = gsap.utils.toArray(".js-post");

	// メインのタイムラインを作成
	const mainTl = gsap.timeline({
		scrollTrigger: {
			trigger: ".js-post-trigger",
			start: "top 90%",
			toggleActions: "play none none none",
		},
	});

	posts.forEach((post, index) => {
		const postImage = post.querySelector(".js-post-image");
		const tl = gsap.timeline();

		tl.to(post, {
			opacity: 1,
			duration: 1.2,
			ease: "power2.out",
		}).to(
			postImage,
			{
				filter: "saturate(1)",
				duration: 1,
				ease: "power3.out",
			},
			">"
		);

		mainTl.add(tl, index * 0.15); // 0.15秒ごと
	});

	const rankingPosts = document.querySelectorAll(".js-ranking-post");
	gsap.to(rankingPosts, {
		opacity: 1,
		duration: 1.8,
		stagger: 0.25,
		ease: "power2.out",
		scrollTrigger: {
			trigger: ".js-ranking-post-trigger",
			start: "top 90%",
			toggleActions: "play none none none",
		},
	});

	const slider1 = new fvSlider(".js-slider1-item");
	slider1.startSlider(5000);
	const slider = new fvMainSlider(".js-slider2-item", ".js-slider-copy");
	slider.startSlider(5000);
	const slider3 = new fvSlider(".js-slider3-item");
	slider3.startSlider(5000);

	const scrollObserver_block = new ScrollObserver({
		target: ".js-block-target",
		addClass: "is-active",
		once: true,
		option: {
			rootMargin: "0px 0px -30% 0px",
		},
	});
	// 監視開始;
	scrollObserver_block.init();

	const hoverPosts = document.querySelectorAll(".js-post");

	hoverPosts.forEach((hoverPost, index) => {
		const postIndex = index + 1;

		const links = document.querySelectorAll(`.js-journal-link--${postIndex}`);

		links.forEach((link) => {
			link.addEventListener("mouseenter", () => {
				document.querySelector(`.js-post--${postIndex}`).classList.add("is-hover");
			});

			link.addEventListener("mouseleave", () => {
				document.querySelector(`.js-post--${postIndex}`).classList.remove("is-hover");
			});
		});
	});
});
window.addEventListener("load", () => {});

class fvSlider {
	constructor(sliderClass) {
		this.slides = document.querySelectorAll(sliderClass);
		this.currentIndex = 0;
		this.updateClasses();
	}

	updateClasses() {
		this.slides.forEach((slide, index) => {
			slide.classList.remove("is-active", "is-next", "is-prev");
			if (index === this.currentIndex) {
				slide.classList.add("is-active");
			} else if (index === (this.currentIndex + 1) % this.slides.length) {
				slide.classList.add("is-next");
			} else if (index === (this.currentIndex - 1 + this.slides.length) % this.slides.length) {
				slide.classList.add("is-prev");
			}
		});
	}

	nextSlide() {
		this.currentIndex = (this.currentIndex + 1) % this.slides.length;
		this.updateClasses();
	}

	startSlider(interval = 5000) {
		this.stopSlider();
		this.intervalId = setInterval(() => this.nextSlide(), interval);
	}

	stopSlider() {
		clearInterval(this.intervalId);
	}
}

class fvMainSlider {
	constructor(sliderClass, copyClass) {
		this.slides = document.querySelectorAll(sliderClass);
		this.copies = document.querySelectorAll(copyClass);
		this.currentSlide = 0;
		this.nextSlideIndex = 1;
		this.prevSlideIndex = this.slides.length - 1;

		// Set initial state
		this.setActiveClasses(this.currentSlide);
		this.slides[this.nextSlideIndex].classList.add("is-next");
		this.setPrevClasses(this.prevSlideIndex);

		this.intervalId = null;
	}

	setActiveClasses(index) {
		const slide = this.slides[index];
		const copy = this.copies[index];
		slide.classList.add("is-active");
		copy?.classList.add("is-active");
		slide.querySelector(".js-slider-category")?.classList.add("is-active");
	}

	removeActiveClasses(index) {
		const slide = this.slides[index];
		const copy = this.copies[index];
		slide.classList.remove("is-active");
		copy?.classList.remove("is-active");
		slide.querySelector(".js-slider-category")?.classList.remove("is-active");
	}

	setPrevClasses(index) {
		const slide = this.slides[index];
		slide.classList.add("is-prev");
	}

	removePrevClasses(index) {
		const slide = this.slides[index];
		slide.classList.remove("is-prev");
	}

	showSlide(index) {
		// Remove classes from current slide
		this.removeActiveClasses(this.currentSlide);

		// Remove is-next from next slide
		this.slides[this.nextSlideIndex].classList.remove("is-next");

		// Remove is-prev from previous slide
		this.removePrevClasses(this.prevSlideIndex);

		// Set new current slide
		this.currentSlide = index;

		// Set new next slide
		this.nextSlideIndex = (index + 1) % this.slides.length;

		// Set new previous slide
		this.prevSlideIndex = (index - 1 + this.slides.length) % this.slides.length;

		// Apply new classes
		this.setActiveClasses(this.currentSlide);
		this.slides[this.nextSlideIndex].classList.add("is-next");
		this.setPrevClasses(this.prevSlideIndex);
	}

	nextSlide() {
		const nextIndex = (this.currentSlide + 1) % this.slides.length;
		this.showSlide(nextIndex);
	}

	startSlider(interval = 5000) {
		// Stop any existing slider
		if (this.intervalId !== null) {
			this.stopSlider();
		}

		// Set new interval
		this.intervalId = setInterval(() => {
			this.nextSlide();
		}, interval);
	}

	stopSlider() {
		if (this.intervalId !== null) {
			clearInterval(this.intervalId);
			this.intervalId = null;
		}
	}
}
